import { defineComponent } from 'vue'

const getHeaderIcon = (icon: string) => {
  switch (icon) {
    case 'overview':
      return (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 20.6032V8.73016C22 8.51331 21.9503 8.29944 21.8548 8.10548C21.7594 7.91152 21.6208 7.74281 21.45 7.6127L11.825 0.279365C11.587 0.098026 11.2975 0 11 0C10.7025 0 10.413 0.098026 10.175 0.279365L0.55 7.6127C0.379231 7.74281 0.240626 7.91152 0.145162 8.10548C0.0496994 8.29944 0 8.51331 0 8.73016V20.6032C0 20.9736 0.144866 21.3289 0.402728 21.5909C0.660591 21.8528 1.01033 22 1.375 22H6.875C7.23967 22 7.58941 21.8528 7.84727 21.5909C8.10513 21.3289 8.25 20.9736 8.25 20.6032V16.4127C8.25 16.0422 8.39487 15.6869 8.65273 15.425C8.91059 15.163 9.26033 15.0159 9.625 15.0159H12.375C12.7397 15.0159 13.0894 15.163 13.3473 15.425C13.6051 15.6869 13.75 16.0422 13.75 16.4127V20.6032C13.75 20.9736 13.8949 21.3289 14.1527 21.5909C14.4106 21.8528 14.7603 22 15.125 22H20.625C20.9897 22 21.3394 21.8528 21.5973 21.5909C21.8551 21.3289 22 20.9736 22 20.6032Z"
            fill="#C0C0C0"
          />
        </svg>
      )

    case 'dashboard':
      return (
        <svg
          width="23"
          height="22"
          viewBox="0 0 23 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="14" height="10" rx="2" fill="#C0C0C0" />
          <rect y="12" width="8" height="10" rx="2" fill="#C0C0C0" />
          <rect x="16" width="7" height="10" rx="2" fill="#C0C0C0" />
          <rect x="10" y="12" width="13" height="10" rx="2" fill="#C0C0C0" />
        </svg>
      )

    case 'caret-up':
      return (
        <svg
          class="caret-icon dashboardUp"
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.16602e-07 4.66623C8.65434e-08 5.01006 0.136961 5.35388 0.421161 5.60945C0.979283 6.13018 1.88448 6.13018 2.45337 5.60945L5.00128 3.23225L7.5492 5.60945C8.10732 6.13018 9.01253 6.13018 9.58141 5.60945C10.1395 5.08873 10.1395 4.24417 9.58141 3.71341L6.01228 0.392943C5.73836 0.137373 5.38054 -4.03846e-07 5.00133 -4.36998e-07C4.62211 -4.7015e-07 4.2536 0.137372 3.99037 0.392942L0.421247 3.72333C0.137047 3.98848 1.45788e-07 4.33238 1.16602e-07 4.66623Z"
            fill="#9B9B9B"
          />
        </svg>
      )

    case 'caret-down':
      return (
        <svg
          class="caret-icon dashboardDown"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2119 2.12436C11.2119 1.70966 11.0584 1.29495 10.7397 0.986688C10.114 0.358606 9.09905 0.358605 8.46122 0.986688L5.60452 3.85398L2.74781 0.986687C2.12205 0.358605 1.10715 0.358604 0.469322 0.986687C-0.15644 1.61477 -0.156441 2.63344 0.469321 3.27363L4.471 7.27865C4.77812 7.58691 5.1793 7.7526 5.60447 7.7526C6.02964 7.7526 6.44282 7.58691 6.73794 7.27865L10.7396 3.26166C11.0583 2.94184 11.2119 2.52705 11.2119 2.12436Z"
            fill="#9B9B9B"
          />
        </svg>
      )

    case 'report':
      return (
        <svg
          width="24"
          height="29"
          viewBox="0 0 24 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="svg-icon"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4 0C2.93913 0 1.92172 0.381918 1.17157 1.06174C0.421427 1.74156 0 2.66359 0 3.625V25.375C0 26.3364 0.421427 27.2584 1.17157 27.9383C1.92172 28.6181 2.93913 29 4 29H20C21.0609 29 22.0783 28.6181 22.8284 27.9383C23.5786 27.2584 24 26.3364 24 25.375V9.81287C23.9998 8.85154 23.5782 7.92966 22.828 7.25L16 1.06212C15.25 0.382258 14.2328 0.000205311 13.172 0H4ZM8 18.125C8 17.6443 7.78929 17.1833 7.41421 16.8434C7.03914 16.5035 6.53043 16.3125 6 16.3125C5.46957 16.3125 4.96086 16.5035 4.58579 16.8434C4.21071 17.1833 4 17.6443 4 18.125V23.5625C4 24.0432 4.21071 24.5042 4.58579 24.8441C4.96086 25.184 5.46957 25.375 6 25.375C6.53043 25.375 7.03914 25.184 7.41421 24.8441C7.78929 24.5042 8 24.0432 8 23.5625V18.125ZM12 12.6875C12.5304 12.6875 13.0391 12.8785 13.4142 13.2184C13.7893 13.5583 14 14.0193 14 14.5V23.5625C14 24.0432 13.7893 24.5042 13.4142 24.8441C13.0391 25.184 12.5304 25.375 12 25.375C11.4696 25.375 10.9609 25.184 10.5858 24.8441C10.2107 24.5042 10 24.0432 10 23.5625V14.5C10 14.0193 10.2107 13.5583 10.5858 13.2184C10.9609 12.8785 11.4696 12.6875 12 12.6875ZM20 10.875C20 10.3943 19.7893 9.93328 19.4142 9.59337C19.0391 9.25346 18.5304 9.0625 18 9.0625C17.4696 9.0625 16.9609 9.25346 16.5858 9.59337C16.2107 9.93328 16 10.3943 16 10.875V23.5625C16 24.0432 16.2107 24.5042 16.5858 24.8441C16.9609 25.184 17.4696 25.375 18 25.375C18.5304 25.375 19.0391 25.184 19.4142 24.8441C19.7893 24.5042 20 24.0432 20 23.5625V10.875Z"
            fill="#C0C0C0"
          />
        </svg>
      )

    case 'ask':
      return (
        <svg
          width="30"
          height="29"
          viewBox="0 0 30 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 26.7224C23.2838 26.7224 30 20.7404 30 13.3612C30 5.982 23.2838 0 15 0C6.71625 0 0 5.982 0 13.3612C0 16.7206 1.39313 19.7937 3.69375 22.1414C3.51188 24.0807 2.91188 26.2071 2.24813 27.8028C2.1 28.1578 2.38688 28.5548 2.76 28.4937C6.99 27.7875 9.50437 26.7033 10.5975 26.1383C12.0333 26.5296 13.5136 26.726 15 26.7224Z"
            fill="#C0C0C0"
          />
        </svg>
      )

    default:
      console.error('Icon not implemented')
  }
}

export default defineComponent({
  name: 'MenuIcon',
  props: {
    type: {
      required: true,
      type: String,
    },
  },
  setup(props: any) {
    return () => getHeaderIcon(props.type)
  },
})
